const _ = require('underscore');

const TYPE_MULTIPLE_CHOICE = 0;
const TYPE_WRITTEN_ANSWER = 1;
const TYPE_CLICK_TOUCH_WORD = 2;
const TYPE_WHO_WHAT = 3;
const TYPE_EXTERNAL_ACTIVITY = 4;
const TYPE_IMAGE_ANSWER = 5;
const TYPE_VOCAB_MULTIPLE_CHOICE = 6;
const TYPE_SPOKEN = 7;
const TYPE_TRUE_FALSE = 8;

const Grading = (module.exports = {
	TYPE_MULTIPLE_CHOICE,
	TYPE_WRITTEN_ANSWER,
	TYPE_CLICK_TOUCH_WORD,
	TYPE_WHO_WHAT,
	TYPE_EXTERNAL_ACTIVITY,
	TYPE_IMAGE_ANSWER,
	TYPE_VOCAB_MULTIPLE_CHOICE,
	TYPE_SPOKEN,
	TYPE_TRUE_FALSE,

	questionTypeIsScorable: function (t) {
		return t === TYPE_MULTIPLE_CHOICE || t === TYPE_IMAGE_ANSWER || t === TYPE_VOCAB_MULTIPLE_CHOICE;
	},

	/**
	 * Iterate over answers for q questionSet in a classAssessment
	 * student.answers[qsetId] property. For TYPE_WHO_WHAT questions the callback
	 * is called for each subQuestion, for other types the callback is called with
	 * the top-level question
	 * @param  {Array}   answers array of question answers from student.answers[qsedId] in classAssessmentSummary (as/a/c)
	 * @param  {Function} cb      function takes one param, the answer for the question
	 */
	eachQuestionAndSubQuestion: function (answers, cb) {
		_.each(answers, function (q) {
			if (q.questionType === TYPE_WHO_WHAT) {
				_.each(q.subQuestions, function (sq) {
					cb(sq);
				});
			} else {
				cb(q);
			}
		});
	},

	/**
	 * Takes an object from students[k].answers[k][k] (beatrice.classAssessment)
	 * and returns true false if the question is answered
	 * @param  {object} answerData answer from students[k].answers[k][k] (smap[k].ans[k][k] on server)
	 * @return {Boolean}           is the question answered?
	 */
	/* eslint-disable consistent-return */
	isAnswered: function (answerData) {
		switch (answerData.questionType) {
			case TYPE_MULTIPLE_CHOICE:
			case TYPE_VOCAB_MULTIPLE_CHOICE:
			case TYPE_IMAGE_ANSWER:
				return !!answerData.answerId;
			case TYPE_WRITTEN_ANSWER:
				return !!answerData.answerText;
			case TYPE_WHO_WHAT:
				var anySubquestionsAnswered = false;
				_.each(answerData.subQuestions, function (subq) {
					if (subq.answerText) {
						anySubquestionsAnswered = true;
					}
				});
				return anySubquestionsAnswered;

			case TYPE_CLICK_TOUCH_WORD:
			case TYPE_EXTERNAL_ACTIVITY:
				return false;
		}
	},
	/* eslint-enable consistent-return */

	studentAssessmentSummary: function (uid, qsetId, assessmentForQset, article, opts) {
		var report = {
			multipleChoiceQuestions: [],
			openResponseQuestions: [],
			multipleChoiceQuestionsCorrect: 0,
			openResponseQuestionsCorrect: 0,
			openResponseQuestionsGraded: 0,
			openResponseQuestionsAllGraded: true,
			percentTotalCorrect: 0,
			openResponsePercentCorrect: 0,
			multipleChoicePercentCorrect: 0,
			totalCorrect: 0,
			firstUnansweredQuestion: null
		};

		if (!qsetId || !assessmentForQset || !article || !uid || !opts) {
			report.openResponseQuestionsAllGraded = false;
			return report;
		}

		let questions = article.getQuestions(qsetId, _.contains(opts.expressqs || [], parseInt(qsetId)));

		var studentAnswers = [];
		if (assessmentForQset) {
			_.each(questions, function (q) {
				studentAnswers.push(assessmentForQset[q.qid]);
			});

			var unansweredQuestionFound = false;

			Grading.eachQuestionAndSubQuestion(studentAnswers, function (a) {
				if (Grading.questionTypeIsScorable(a.questionType)) {
					report.multipleChoiceQuestions.push(a);
					if (typeof a.score === 'number') {
						report.multipleChoiceQuestionsCorrect += a.score / 100;
					}
				} else {
					report.openResponseQuestions.push(a);
					if (typeof a.score === 'number') {
						report.openResponseQuestionsCorrect += a.score / 100;
						report.openResponseQuestionsGraded += 1;
					} else {
						report.openResponseQuestionsAllGraded = false;

						if (!unansweredQuestionFound) {
							report.firstUnansweredQuestion = a.qid;

							unansweredQuestionFound = true;
						}
					}
				}
			});
		}

		report.totalCorrect = report.openResponseQuestionsCorrect + report.multipleChoiceQuestionsCorrect;
		if (questions.length > 0) {
			report.percentTotalCorrect = Math.round(
				(report.totalCorrect / (report.multipleChoiceQuestions.length + report.openResponseQuestionsGraded)) * 100
			);
		} else {
			report.percentTotalCorrect = 0;
		}

		if (report.openResponseQuestions.length > 0) {
			report.openResponsePercentCorrect = Math.round((report.openResponseQuestionsCorrect / report.openResponseQuestionsGraded) * 100);
		} else {
			report.openResponsePercentCorrect = 0;
		}

		if (report.multipleChoiceQuestions.length > 0) {
			report.multipleChoicePercentCorrect = Math.round((report.multipleChoiceQuestionsCorrect / report.multipleChoiceQuestions.length) * 100);
		} else {
			report.multipleChoicePercentCorrect = 0;
		}

		return report;
	}
});
